
export const routeName = {
  login: '/login',
  forgotPassword: '/forgot-password',
  OTPconfim:'/OTP-confim',
  home: '/',  
  employees: '/employees',
  role: '/role',
  department: '/department',
  position: '/position'
};
